export default __webpack_public_path__ + "ocr/tesseract-core.wasm-4dddf781aabe6641e4a63f7cdf336389.js";